import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { grey } from "@material-ui/core/colors";
import FavoriteIcon from "@material-ui/icons/FavoriteTwoTone";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EditIcon from "@material-ui/icons/EditTwoTone";
import DateIcon from "@material-ui/icons/ScheduleTwoTone";
import LooksOneTwoToneIcon from "@material-ui/icons/LooksOneTwoTone";
import LooksTwoTwoToneIcon from "@material-ui/icons/LooksTwoTwoTone";
import Looks3TwoToneIcon from "@material-ui/icons/Looks3TwoTone";
import Looks4TwoTone from "@material-ui/icons/Looks4TwoTone";
import Looks5TwoTone from "@material-ui/icons/Looks5TwoTone";
import Looks6TwoTone from "@material-ui/icons/Looks6TwoTone";
import Looks7TwoTone from "@material-ui/icons/Filter7TwoTone";

import ToggleOn from "@material-ui/icons/ToggleOn";
import ToggleOff from "@material-ui/icons/ToggleOff";

import ShuffleIcon from "@material-ui/icons/ShuffleTwoTone";
import TranslateIcon from "@material-ui/icons/TranslateTwoTone";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import SettingsDialog from "./SettingsDialog";
import AutoPlaySettingsDialog from "./AutoPlaySettingsDialog";
import { SpeakItem } from "./SpeakItem";
//import "./WordCard.css";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import EditExistingWordDialog from "../dashboard/EditExistingWordDialog";

let booked = false;

const useStyles = (theme) => ({
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  booked: {
    color: "orange",
  },
  avatar: {
    backgroundColor: grey[600],
  },
});

//export default function RecipeReviewCard(props) {
export class WordCard extends Component {
  state = {
    selected: 0,
    expanded: false,
    open: false,
    fullSize: true,
  };

  // let selected=0;

  nextClick = () => {
    this.setState({
      selected: 1,
    });
  };

  handleExpandClick = () => {
    let tempexopanded = !this.state.expanded;
    this.setState({
      expanded: tempexopanded,
    });
  };

  handleBookmarkClick = () => {
    this.props.handleBookmark(!booked);
  };

  ClickEdit() {
    //open edit dialog in new window
    //  this.props.ClickEdit();

    this.setState({
      open: true,
    });
  }
  ClickLevel() {
    this.props.ClickLevel();
  }

  handleSettingsChanged = (
    Right,
    Left,
    Up,
    Down,
    SpanishVoice,
    GermanVoice,
    EnglishVoice,
    FrenchVoice,
    ItalianVoice,
    X,
    Y,
    A,
    B,
    Start,
    Select,
    Speed
  ) => {
    //alert("ds");
    this.props.handleSettingsChanged(
      Right,
      Left,
      Up,
      Down,
      SpanishVoice,
      GermanVoice,
      EnglishVoice,
      FrenchVoice,
      ItalianVoice,
      X,
      Y,
      A,
      B,
      Start,
      Select,
      Speed
    );
  };

  handleAutoPlaySettingsChanged = (autoPlaySettings) => {
    this.props.handleAutoPlaySettingsChanged(autoPlaySettings);
  };

  handleTextSpeakClick = (text, voice, iframe) => {
    console.log(text);
    document.getElementById("speakdiv").innerHTML = text;
    document.getElementById("voicediv").innerHTML = voice;
    document.getElementById("speakdiv").click();
    if (iframe) {
      this.props.handleIframeChanage(text, voice);
    }
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleToggleSize = () => {
    const temp = !this.state.fullSize;
    this.setState({
      fullSize: temp,
    });
  };

  render() {
    const { classes } = this.props;
    // let bookmarked = (
    //   <IconButton
    //     onClick={this.handleBookmarkClick}
    //     aria-label="Add to favorites"
    //   >
    //     <FavoriteIcon />
    //   </IconButton>
    // );
    let longWordsComponent = (
      <IconButton
        onClick={() => this.props.ToggleLongWords()}
        aria-label="Show long words"
      >
        {this.props.longWords ? <ToggleOn /> : <ToggleOff />}
      </IconButton>
    );
    let level = (
      <IconButton
        onClick={() => this.ClickLevel()}
        aria-label="Add to favorites"
      >
        <LooksOneTwoToneIcon />
      </IconButton>
    );
    if (this.props.mounted && this.props.words[1] != undefined) {
      // console.log(this.props.selected);
      //  console.log(this.props);
      if (this.props.words[this.props.selected].createdAt != undefined) {
        var date = new Date(
          this.props.words[this.props.selected].createdAt.seconds * 1000
        );
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();
        // Seconds part from the timestamp
        var seconds = "0" + date.getSeconds();

        // Will display time in 10:30:23 format
        var formattedTime =
          day +
          "." +
          month +
          "." +
          year +
          "_" +
          hours +
          ":" +
          minutes.substr(-2) +
          ":" +
          seconds.substr(-2);
      }

      // if (this.props.words[this.props.selected].bookmarked != undefined) {
      //   if (this.props.words[this.props.selected].bookmarked) {
      //     booked = true;
      //     bookmarked = (
      //       <IconButton
      //         className={classes.booked}
      //         onClick={this.handleBookmarkClick}
      //         aria-label="Add to favorites"
      //       >
      //         <FavoriteIcon />
      //       </IconButton>
      //     );
      //   } else {
      //     booked = false;
      //   }
      // }

      if (this.props.words[this.props.selected].level != undefined) {
        if (this.props.words[this.props.selected].level == 2) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <LooksTwoTwoToneIcon />
            </IconButton>
          );
        } else if (this.props.words[this.props.selected].level == 3) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks3TwoToneIcon />
            </IconButton>
          );
        } else if (this.props.words[this.props.selected].level == 4) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks4TwoTone />
            </IconButton>
          );
        } else if (this.props.words[this.props.selected].level == 5) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks5TwoTone />
            </IconButton>
          );
        } else if (this.props.words[this.props.selected].level == 6) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks6TwoTone />
            </IconButton>
          );
        } else if (this.props.words[this.props.selected].level == 7) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks7TwoTone />
            </IconButton>
          );
        }
      }
    }

    let words_s = this.props.words[this.props.selected];

    return (
      <Paper>
        {this.props.words[1] != undefined ? (
          <main
            className={
              this.state.fullSize
                ? "card full-height white"
                : "card full-height-small white"
            }
          >
            <section className="card__header">
              <CardHeader
                avatar={
                  <Avatar aria-label="Recipe" className={classes.avatar}>
                    R
                  </Avatar>
                }
                action={
                  <div className="actions">
                    <div className="actions__counter">
                      {this.props.selected} / {this.props.words.length}
                    </div>
                    <div>
                      <AutoPlaySettingsDialog
                        handleAutoPlaySettingsChanged={
                          this.handleAutoPlaySettingsChanged
                        }
                        autoPlaySettings={this.props.autoPlaySettings}
                      ></AutoPlaySettingsDialog>
                    </div>
                  </div>
                }
                title={this.props.words[this.props.selected].Language1}
                subheader={"set:" + this.props.words[this.props.selected].set}
              />
            </section>
            <section className="card__body">
              <div>
                <SpeakItem
                  languageText="Language4"
                  voice="FrenchVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="h6"
                ></SpeakItem>
                <SpeakItem
                  languageText="Language1"
                  voice="SpanishVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="h6"
                ></SpeakItem>
                <SpeakItem
                  languageText="Language2"
                  voice="GermanVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="h6"
                ></SpeakItem>
                <Typography
                  onClick={() =>
                    this.handleTextSpeakClick(
                      words_s.Language3,
                      "EnglishVoice",
                      true
                    )
                  }
                  className="MySpeakText backcolor black-row"
                  variant="h6"
                  gutterBottom
                >
                  {this.props.words[this.props.selected].Language3}
                </Typography>
                <SpeakItem
                  languageText="Language5"
                  voice="ItalianVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="h6"
                ></SpeakItem>
                {/* DESCRIPTION */}
                <SpeakItem
                  languageText="Description4"
                  voice="FrenchVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="body1"
                ></SpeakItem>
                <SpeakItem
                  languageText="Description1"
                  voice="SpanishVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="body1"
                ></SpeakItem>
                <SpeakItem
                  languageText="Description2"
                  voice="GermanVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="body1"
                ></SpeakItem>
                <SpeakItem
                  languageText="Description3"
                  voice="EnglishVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="body1"
                ></SpeakItem>
                <SpeakItem
                  languageText="Description5"
                  voice="ItalianVoice"
                  word={this.props.words[this.props.selected]}
                  handleTextSpeakClick={this.handleTextSpeakClick}
                  UpdateField={this.props.UpdateField}
                  variant="body1"
                ></SpeakItem>
                {/* <div
                  onClick={() =>
                    this.handleTextSpeakClick(
                      words_s.Description5,
                      "ItalianVoice"
                    )
                  }
                  className="MySpeakText"
                >
                  {" "}
                  {this.props.words[this.props.selected].Description5}
                </div> */}
              </div>
            </section>
            <section className="card__footer">
              {/* {bookmarked} */}
              {longWordsComponent}
              <SettingsDialog
                settingSpeak={this.props.settingSpeak}
                handleSettingsChanged={this.handleSettingsChanged}
              ></SettingsDialog>
              <IconButton onClick={() => this.ClickEdit()} aria-label="Share">
                <EditIcon />
              </IconButton>
              {level}
              <IconButton
                onClick={() => this.props.ChangeDate()}
                aria-label="Share"
              >
                <DateIcon />
              </IconButton>
              {/* <IconButton
                onClick={() => this.props.Shuffle()}
                aria-label="Share"
              >
                <ShuffleIcon />
              </IconButton> */}
              <IconButton
                onClick={() => this.handleToggleSize()}
                aria-label="Share"
              >
                <ShuffleIcon />
              </IconButton>
              <IconButton
                onClick={() => this.props.IframeToggle()}
                aria-label="Share"
              >
                <TranslateIcon />
              </IconButton>
              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: this.state.expanded,
                })}
                onClick={this.handleExpandClick}
                aria-expanded={this.state.expanded}
                aria-label="Show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </section>
          </main>
        ) : (
          /* <Card className={classes.card}>
    

            <CardContent>
        
            
               
            
            </CardContent>

            <CardActions className={classes.actions} disableSpacing>
        
            </CardActions>
            <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
              <CardContent></CardContent>
            </Collapse>
          </Card> */

          <div></div>
        )}

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">
            Editar una nueva oración
          </DialogTitle>
          <DialogContent>
            <EditExistingWordDialog
              word={this.props.words[this.props.selected]}
              sets={this.props.sets}
              handleClose={this.handleClose}
              collection_name={this.props.collection_name}
              editWord={this.props.editWord}
            ></EditExistingWordDialog>
          </DialogContent>
          {/* <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Subscribe
            </Button>
          </DialogActions> */}
        </Dialog>
      </Paper>
    );
  }
}

WordCard.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default WordCard;
export default withStyles(useStyles)(WordCard);
